import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { api, casApi } from '@lib/api';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    api: api.reducer,
    casApi: casApi.reducer,
  },
  middleware: (defaultMiddleware) => defaultMiddleware().concat(sagaMiddleware, api.middleware, casApi.middleware),
});

// sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
